module.exports = __webpack_public_path__ + "static/media/near-school.3f70fdd6.svg";